import { sbxCoreService} from '../Network';

export function getZones() {
  return sbxCoreService.with("zone").loadAll();
}

export function getZonesByCity(cityId: string) {
  return sbxCoreService.with("zone")
    .andWhereIsEqualTo("city", cityId)
    .loadAll()
}
